export default {
  wild: '*',
  root: '/',
  signIn: 'sign-in',
  home: 'home',
  signUp: 'sign-up',
  dashboard: 'dashboard',
  workflow: 'workflow',
  account: 'account',
  myAccount: 'my-account',
  profile: 'profile',
  signatures: 'signatures',
  security: 'security',
  provisions: 'provisions',
  stamps: 'stamps',
  invitations: 'invitations',
  documents: 'documents',
  design: 'design',
  demo1: 'demo1',
  demo2: 'demo2',
  settings: 'settings',
  settings1: 'settings1',
  settings2: 'settings2',
  termsConditions: 'terms-conditions',
  privacyPolicy: 'privacy-policy',
  verifier: 'verifier',
};
